exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2j9zdy5yJdj8W4rS9IBQiN,._1LhmsFhdj3DfnCliilsYM9{font-size:12px}._1LhmsFhdj3DfnCliilsYM9{display:-webkit-box;display:-ms-flexbox;display:flex}html[dir] ._2mWUe46WJoc6FLoyErTzic{padding-top:1px;padding-bottom:1px}html[dir=ltr] ._2mWUe46WJoc6FLoyErTzic{padding-left:15px}html[dir=rtl] ._2mWUe46WJoc6FLoyErTzic{padding-right:15px}._2i3mhfGJ-gt8AnPyMJbEMM{width:24px;height:24px;line-height:32px}", ""]);
// Exports
exports.locals = {
	"roomPersonaPrimaryText": "_2j9zdy5yJdj8W4rS9IBQiN",
	"roomPersonaSecondaryText": "_1LhmsFhdj3DfnCliilsYM9",
	"roomPersona": "_2mWUe46WJoc6FLoyErTzic",
	"roomIcon": "_2i3mhfGJ-gt8AnPyMJbEMM"
};